// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import Vue2Leaflet from 'vue2-leaflet'

window._ = require('underscore')
window.$ = require('jquery')
window.slick = require('slick-carousel')

// Vue.component('v-map', Vue2Leaflet.Map);
// Vue.component('v-tilelayer', Vue2Leaflet.TileLayer);
// Vue.component('v-marker', Vue2Leaflet.Marker);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js